import { Link } from "@inertiajs/react";
import ImpersonationBanner from "@components/shared/ImpersonationBanner";
import { PageProviders } from "./page-providers";

/**
 * Minimal-chrome layout for authenticated (or about-to-be-authenticated)
 * pages that don't want the sidebar/workflow: embedded checkout, future
 * signup/signin. Shares all identity + reliability providers with SiteLayout
 * via PageProviders — so PostHog identify, Sentry, flash bridging, JWT
 * refresh, and error boundary still run.
 */
export const SiteLight = ({ children }: { children: React.ReactNode }): React.ReactNode => {
  return (
    <PageProviders>
      <div className="min-h-screen bg-background flex flex-col">
        <ImpersonationBanner />
        <header className="px-6 py-4">
          <nav>
            <Link href="/" aria-label="Launch10">
              <img src="/images/launch10-logo.svg" alt="Launch10" className="h-8" />
            </Link>
          </nav>
        </header>
        <main className="flex-1">{children}</main>
      </div>
    </PageProviders>
  );
};
